import { render, staticRenderFns } from "./PostSearch.vue?vue&type=template&id=6cddbec5&"
import script from "./PostSearch.vue?vue&type=script&lang=js&"
export * from "./PostSearch.vue?vue&type=script&lang=js&"
import style0 from "./PostSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports